var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_8355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6725 8.8076L18.6713 8.80635L11.1927 1.3281C10.8739 1.00913 10.4501 0.833496 9.99935 0.833496C9.54854 0.833496 9.12472 1.00902 8.80582 1.32796L1.33116 8.80241C1.32865 8.80491 1.32614 8.80756 1.32364 8.81011C0.669008 9.46846 0.670154 10.5367 1.32686 11.1934C1.62685 11.4935 2.02313 11.6674 2.4468 11.6856C2.46399 11.6873 2.48136 11.6881 2.49883 11.6881H2.79689V17.1917C2.79689 18.2807 3.68298 19.1668 4.77231 19.1668H7.69812C7.99468 19.1668 8.23523 18.9264 8.23523 18.6297V14.3149C8.23523 13.818 8.6395 13.4137 9.13647 13.4137H10.8622C11.3592 13.4137 11.7634 13.818 11.7634 14.3149V18.6297C11.7634 18.9264 12.0038 19.1668 12.3005 19.1668H15.2264C16.3157 19.1668 17.2018 18.2807 17.2018 17.1917V11.6881H17.4782C17.9288 11.6881 18.3527 11.5126 18.6717 11.1937C19.3291 10.5359 19.3294 9.46585 18.6725 8.8076Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_8355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.acff3d351268ead958d4b2093798dfbf.svg";
export { ForwardRef as ReactComponent };